import { render, staticRenderFns } from "./input_form.vue?vue&type=template&id=49d4b9ca&scoped=true"
import script from "./input_form.vue?vue&type=script&lang=js"
export * from "./input_form.vue?vue&type=script&lang=js"
import style0 from "./input_form.vue?vue&type=style&index=0&id=49d4b9ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d4b9ca",
  null
  
)

export default component.exports